import axios from "../axios";
import _ from 'lodash';

const ACTIONS = {
    SET_CONDITION_DETAIL_SEARCH: 'SET_CONDITION_DETAIL_SEARCH'
};

const getYear = () => {
    return async () => {
        try {
            const response = await axios.get('api/masters/years');
            return _.uniq(response.data);
        } catch (error) {
            return error;
        }
    };
};

const setCondition = (value, field) =>  {
    return (dispatch) => {
        dispatch({
            type: ACTIONS.SET_CONDITION_DETAIL_SEARCH,
            body: {
                value,
                field
            }
        })
    }
};

const getDetailSearch = (params, type) => {
    return async () => {
        const {data} = await axios.post(`api/detailsearch/${type}/result`, params);
        return data;
    };
};

export {ACTIONS, getYear, setCondition, getDetailSearch}
